import { memo, useCallback } from 'react';

import type { WorkItem } from '../common/models';
import { SearchResultRow } from '../components';
import { WorkItemAssignee } from './WorkItemAssignee';
import { WorkItemStateDot } from './WorkItemStateDot';
import { WorkItemTypeBadge } from './WorkItemTypeBadge';

export type WorkItemResultRowProps = {
    item: WorkItem;
    selected: boolean;
    onSelect: (item: WorkItem) => void;
};

export const WorkItemResultRow = memo(function WorkItemResultRow({ item, selected, onSelect }: WorkItemResultRowProps) {
    const handleSelect = useCallback(() => onSelect(item), [onSelect, item]);
    return (
        <SearchResultRow
            id={item.id}
            title={item.title}
            selected={selected}
            avatar={<WorkItemAssignee item={item} size={32} />}
            stateDot={<WorkItemStateDot state={item.state} />}
            badge={<WorkItemTypeBadge workItemType={item.workItemType} title={item.title} />}
            onSelect={handleSelect}
        />
    );
});
